import React from "react";
import {  Routes, Route, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
/// Css
import './index.css'
import './chart.css'
import './step.css'

/// Layout
import Nav from './layouts/nav'
import Footer from './layouts/Footer'

/// Dashboard
import Home from "./components/Dashboard/Home";
import Analytics from "./components/Dashboard/Analytics";
import OrderList from "./components/Dashboard/OrderList";
import CustomerList from "./components/Customer/CustomerList";
import Reviews from "./components/Dashboard/Reviews";
import Task from './components/Dashboard/Task';

import CustomerListNew from "./components/Customer/CustomerListNew";

//Property
import AddProperty from "./components/Property/AddProperty";
import PropertyDetails from './components/Property/PropertyDetails';
import PropertyList from "./components/Property/PropertyList";
import VerificationListNew from "./components/Property/VerificationListNew";
import ReportList from './components/Property/ReportList';
import BankVerficationList from "./components/Property/BankVerficationList";

//Report
import PropertyReport from "./components/Report/PropertyReport";
// import PaymentReport from "./components/Report/PaymentReport";
import CustomerReport from "./components/Report/CustomerReport";
import PropertyVerificationReport from "./components/Report/PropertyVerificationReport";
import BankVerificationReport from "./components/Report/BankVerificationReport";

/// Charts
// eslint-disable-next-line no-unused-vars
import ChartJs from './components/charts/Chartjs'

/// Pages
import Error404 from './pages/Error404'

import User from './pages/User';
import Role from './pages/Role';
import Policy from './pages/Policy';
import PropertyType from './pages/PropertyType';
import ListingType from './pages/ListingType';
import OwnershipType from './pages/OwnershipType';
import FurnishingStatus from './pages/FurnishingStatus';
import FacingDirection from './pages/FacingDirection';
import AvailabilityStatus from './pages/AvailabilityStatus';
import Amenity from './pages/Amenity';
import Feature from './pages/Feature';
import PriceUnit from './pages/PriceUnit';
import PurchasePlan from './pages/PurchasePlan';
import Subscription from './pages/Subscription';
import Payment from './pages/Payment';
import Bank from './pages/Bank';
import Support from './pages/Support';
//Scroll To Top
import ScrollToTop from './layouts/ScrollToTop';



const Markup = () => {
  const allroutes = [
    /// Dashboard
    { url: "", component: <Home/> },
    { url: "dashboard", component: <Home/> },
    { url: "analytics", component: <Analytics/> },
    { url: "review", component: <Reviews/> },
    { url: "order-list", component: <OrderList/> }, 
	  { url: 'task', component: <Task/> },
    

    //property    
	  { url: 'add-property', component: <AddProperty/> },
    { url: 'edit-property/:id', component: <AddProperty/> },
	  { url: 'property-list', component: <PropertyList/> },
    { url: 'pending-property-list', component: <PropertyList/> },
    { url: 'blocked-property-list', component: <PropertyList/> },
    { url: 'sold-property-list', component: <PropertyList/> },
    { url: 'featured-property-list', component: <PropertyList/> },
    { url: 'verified-property-list', component: <PropertyList/> },
    { url: 'rejected-property-list', component: <PropertyList/> },
    { url: 'property-details/:id', component: <PropertyDetails/> },
	  { url: 'property-details', component: <PropertyDetails/> },
    { url: 'pending-verification-list', component: <VerificationListNew/> },
    { url: 'verification-list', component: <VerificationListNew/> },
    { url: 'completed-list', component: <VerificationListNew/> },
    { url: 'reported-property-list', component: <ReportList/> },
    { url: 'pending-bank-verification-list', component: <BankVerficationList/> },
    { url: 'bank-verification-list', component: <BankVerficationList/> },
    { url: 'bank-completed-list', component: <BankVerficationList/> },

    //Customers 
    { url: "customer-list-old", component: <CustomerList/> },
    { url: "customer-list", component: <CustomerListNew/> },

    //Report
    { url: "property-report", component: <PropertyReport/> },
    { url: "payment-report", component: <Payment/> },
    { url: "customer-report", component: <CustomerReport/> },
    { url: "property-verification-report", component: <PropertyVerificationReport/> },
    { url: "bank-verification-report", component: <BankVerificationReport/> },

    /// pages    
    { url: 'users', component: <User/> },
    { url: 'roles', component: <Role/> },
    { url: 'policies', component: <Policy/> },
    { url: 'property-type', component: <PropertyType/> },
    { url: 'listing-type', component: <ListingType/> },
    { url: 'ownership-type', component: <OwnershipType/> },
    { url: 'furnishing-status', component: <FurnishingStatus/> },
    { url: 'facing-direction', component: <FacingDirection/> },
    { url: 'availability-status', component: <AvailabilityStatus/> },
    { url: 'amenity', component: <Amenity/> },
    { url: 'features', component: <Feature/> },
    { url: 'price-unit', component: <PriceUnit/> },
    { url: 'pricing', component: <PurchasePlan/> },
    { url: 'subscription-list', component: <Subscription/> },
    { url: 'payment-list', component: <Payment/> },
    { url: 'banks', component: <Bank/> },
    { url: 'support', component: <Support/> },
  ]


  function NotFound(){    
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname
    path = path.split('/')
    path = path[path.length - 1]    
      
    if(url.indexOf(path) <= 0){     
      return <Error404 />
    }
  }   

  return (
       <>
         <Routes>                
            <Route  element={<MainLayout />} > 
                {allroutes.map((data, i) => (
                  <Route
                    key={i}
                    exact
                    path={`${data.url}`}
                    element={data.component}
                  />
                ))}
            </Route>                
            <Route path='*' element={<NotFound/>} />               
        </Routes>        
        <ScrollToTop />
       </>
  )
}

function MainLayout(){  
  const sideMenu = useSelector(state => state.sideMenu);
  return (
    <div id="main-wrapper" className={`show  ${ sideMenu ? "menu-toggle" : ""}`}>  
        <Nav />
        <div className="content-body" >          
          <div className="container-fluid" style={{ minHeight: window.screen.height - 45 }}>
             <Outlet />   
          </div>
        </div>
        <Footer />
    </div>
  )
};

export default Markup;
